import { Box } from '@chakra-ui/react'
import React from 'react'
import Slider from "react-slick"
import "./slick.css"
import "./slick-theme.css"
import Herocard from '../Spotify/Herocard'



function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ 
            ...style, 
            display: "block", 

        }
    
    }
        onClick={onClick}
      />
    );
  }
  
  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick}
      />
    );
  }
  

export default function Banner({ items }) {

  const settings = {
    dots: false,
    infinite: true,
    autoplay:true,
    autoplaySpeed:4000,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    
  };
    return (

        <Box 
            borderRadius="10px" 
            my={5} 
            px={12} 
            py={3}
            position="relative"
            sx={{
                '.slick-prev': {
                    left: '-40px',
                    zIndex: 2,
                    width: '40px',
                    height: '40px',
                    '&:before': {
                        fontSize: '24px',
                        color: 'var(--chakra-colors-primary-900)',
                        opacity: 1,
                    }
                },
                '.slick-next': {
                    right: '-56px',
                    zIndex: 2,
                    width: '40px',
                    height: '40px',
                    '&:before': {
                        fontSize: '24px',
                        color: 'var(--chakra-colors-primary-900)',
                        opacity: 1,
                    }
                },
            }}
        >
            <Slider {...settings} >
                {
                    items.map((item, index) => (
                      
                        <Herocard key={item.track_id || index} item={{item,type:"song"}}/>
                        
                    ))
                }
            </Slider>

        </Box>
    )
}
